import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate, useLocation } from 'react-router-dom';

const locationList = [
    { name: "강남점", url: "/map" },
    { name: "강남2호점", url: "/gangnammap2" },
    { name: "강동점", url: "/gangdongmap" },
    { name: "김포점", url: "/gimpomap" },
    { name: "대치점", url: "/daechimap" },
    { name: "동탄점", url: "/dongtanmap" },
    { name: "분당점", url: "/bundangmap" },
    { name: "수성점", url: "/daegumap" },
    { name: "송파점", url: "/songpamap" },
    { name: "센텀점", url: "/centummap" },
    { name: "신촌점", url: "/sinchonmap" },
    { name: "하남점", url: "/hanammap" },
];

const Locations: React.FC<any> = (props) => {

    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: `(max-width : 1024px)` });
    const location = useLocation();

    return (
        <div>
            <div style={{
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                rowGap: !isMobile ? "25px" : "20px",
                marginTop: "51.71px",
                borderBottom: "1px solid rgba(238, 238, 238, 0.9)",
                paddingBottom: !isMobile ? "25px" : "15px",
                fontSize: !isMobile ? "24px" : "14px",
                fontWeight: !isMobile ? 600 : 500,
                letterSpacing: "-0.41px",
                fontFamily: "Apple_SB",
                width: !isMobile ? "1150px" : "100%",
            }}>
                {locationList.map((item, index) => {

                    var isActive = location.pathname === item.url;

                    if(location.pathname === "/mapmain" && item.name === "수성점"){

                        isActive = true;
                        
                    }

                    return (
                        <div key={index} onClick={(e: any) => {
                            navigate(item.url);
                        }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                color : isActive ? "#1b49af" : "#444"
                            }}
                        >
                            {item.name}
                        </div>

                    )
                })}
            </div>
        </div>
    )
}

export default Locations;